
export enum RouteCategoryCd {
	DELIVERY = 'Delivery',
	DOCK = 'Dock',
	PLANNING = 'Planning'}

